import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbControlePrevisaoVisita } from 'app/abstract/full-pages/config-scond-key/controle-previsao-visita.abstract';


@Injectable({ providedIn: 'root' })
export class ControlePrevisaoVisitaService extends AbControlePrevisaoVisita {
  prefixo: String = "controle_previsao_visitas"

  constructor(http: HttpClient) {
    super(http);
  }

  public getControlePrevisaoVisita() {
    return this.get(`${this.prefixo}/1`).toPromise().catch();
  }

  public salvarControlePrevisaoVisita(controlePrevisaoVisita) {
    return this.save(`${this.prefixo}/`, controlePrevisaoVisita).toPromise().catch();
  }
}